Ext.define('SA.CrosstabResponseMapper', {
    singleton: true,

    map({attributes, response}) {
        var totals = Object.entries(response.totals).map(([attribute, data]) => ({attribute, data})),
            datasetTotal = this.mapDatasetTotal(totals.find(item => item.attribute === 'all')),
            attributeTotals = totals.filter(item => item.attribute !== 'all').map(entry => this.mapAttributeTotal(entry)),
            crosstabValues = this.mapCrosstabValues({attributes, values: response.crossTab});

        return [datasetTotal, ...attributeTotals, ...crosstabValues];
    },

    mapAttributeTotal(entry) {
        var id = SA.CrosstabDataId.get(['total', entry.attribute]),
            data = Object.assign(entry.data, {
               index: 100,
               [`% of ${entry.attribute}`]: 100,
               ['% of total']: entry.data['% of all']
            });

        return {id, data};
    },

    mapCrosstabValues({attributes, values}) {
        return SA.Array.flatMap(attributes.top, (topAttribute, topIndex) => {
            return attributes.left.map((leftAttribute, leftIndex) => {
                var id = SA.CrosstabDataId.get([topAttribute, leftAttribute]),
                    value = values[topIndex][leftIndex],
                    data = Ext.isObject(value) ? value : null;

                return {id, data};
            });
        });
    },

    mapDatasetTotal(entry) {
        var id = SA.CrosstabDataId.get(['total', 'total']),
            data = Object.assign(entry.data, {
               index: 100,
               ['% of all']: 100,
               ['% of total']: 100
            });

        return {id, data};
    }
});